import auth from './auth';
import definitions from './definitions';
import global from './global';
import membership from './membership';
import settings from './settings';
import company from './company';
import reservation from './reservation';
import kodirectory from './kodirectory';
import ticket from './ticket';
import financial from './financial';
import notification from './notification';
import onlinesales from './onlinesales';
import dailypass from './dailypass';
import sidebar from './sidebar';

export const actions = {
  auth: auth.actions,
  definitions: {...definitions.actions, ...global.actions('definitions')},
  membership: {...membership.actions, ...global.actions('membership')},
  settings: {...settings.actions, ...global.actions('settings')},
  company: {...company.actions, ...global.actions('company')},
  reservation: {...reservation.actions, ...global.actions('reservation')},
  kodirectory: {...kodirectory.actions, ...global.actions('kodirectory')},
  ticket: {...ticket.actions, ...global.actions('ticket')},
  financial: {...financial.actions, ...global.actions('financial')},
  notification: {...notification.actions, ...global.actions('notification')},
  onlinesales: {...onlinesales.actions, ...global.actions('onlinesales')},
  dailypass: {...dailypass.actions, ...global.actions('dailypass')},
  sidebar: {...sidebar.actions, ...global.actions('sidebar')}

};

export const reducers = {
  auth: auth.reducers,
  definitions: definitions.reducers,
  company: company.reducers,
  membership: membership.reducers,
  settings: settings.reducers,
  reservation: reservation.reducers,
  kodirectory: kodirectory.reducers,
  ticket: ticket.reducers,
  financial: financial.reducers,
  notification: notification.reducers,
  onlinesales : onlinesales.reducers,
  dailypass : dailypass.reducers,
  sidebar : sidebar.reducers
};



// WEBPACK FOOTER //
// ./src/store/modules/index.js